import React, { Component } from "react";
import MenuBar from "./navbar";
import SocialMediaLinks from "./socialmedialinks";
import Header from './header';
import Button from 'react-bootstrap/Button';
import { Redirect } from 'react-router-dom';
import { BASE_URL } from "./utility";

class Operations extends Component {

  // Navigation handlers
  navigateTo = (path) => {
    window.location.href = path;
  };

  render() {
    if (!localStorage.getItem("token")) return <Redirect to='/auth' />;

    const actionCards = [
      { title: "Generate Tax Invoice", path: "taxinvoice", variant: "secondary" },
      { title: "Generate Pro-forma Invoice", path: "performainvoice", variant: "primary" },
      { title: "Generate Credit Note", path: "creditnote", variant: "light" },
      { title: "View Reports", path: "invoicereports", variant: "success" },
      { title: "Upload Images", path: "uploadimage", variant: "info" },
      { title: "Delete Images", path: "imageDeletion", variant: "danger" },
    ];

    return (
      <div
        style={{
          backgroundImage: `url(${BASE_URL + "download/general/bg"})`,
          minHeight: "100vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingBottom: "50px"
        }}
      >
        <Header />
        <center>
          <MenuBar />
          <h2 style={{ color: "white", marginTop: "20px" }}>Operations</h2>
        </center>

        <div className="container mt-4">
          <div className="row justify-content-center">
            {actionCards.map((card, index) => (
              <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
                <div
                  className="card shadow-sm text-center h-100"
                  style={{ borderRadius: "15px", backgroundColor: "rgba(255,255,255,0.9)" }}
                >
                  <div className="card-body d-flex flex-column justify-content-center">
                    <h5 className="card-title mb-3">{card.title}</h5>
                    <Button
                      variant={card.variant}
                      className="rounded-pill font-weight-bold"
                      onClick={() => this.navigateTo(card.path)}
                    >
                      Go
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <SocialMediaLinks />
      </div>
    );
  }
}

export default Operations;
